import React, { useRef, useState, useEffect } from "react";
import heropageImage from "../../assets/gif/heropage-main-image.png";
import appleStoreIcon from "../../assets/images/apple-store-icon.svg";
import playStoreIcon from "../../assets/images/play-store-icon.svg";
import heroPageGif from "../../assets/gif/SPT-Gamers-rotate2.GIF";
import Lottie from "react-lottie";
import downloadingData from "../../lotties/downloading";
import QRCode from "react-qr-code";
import "./HeroPage.css";
import AOS from "aos";
import PoweredBy from "../PoweredBy/PoweredBy";
import { useTranslation } from "react-i18next";
import DownloadOnAppStoreMobile from "../Buttons/DownloadOnAppStoreMobile";
import DownloadOnGooglePlayMobile from "../Buttons/DownloadOnGooglePlayMobile";
const HeroPage = () => {
  const { t } = useTranslation();
  const fixedDownloadRef = useRef(0);
  const fixedGifRef = useRef();
  const [hover, setHover] = useState(false);
  const handleToggle = () => {
    setHover(true);
    fixedDownloadRef.current.style.display = "block";
  };
  const disableToggle = () => {
    setHover(false);
    fixedDownloadRef.current.style.display = "none";
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: downloadingData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition >= 3105) {
      fixedGifRef.current.style = "display: none";
    } else if (scrollPosition <= 3104) {
      fixedGifRef.current.style = "display: block";
    }
    console.log(scrollPosition);
  };
  // window.addEventListener("scroll", console.log(window.scrollY));
  // window.addEventListener("scroll", handleScroll);
  useEffect(() => {
    console.log(hover);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hover]);
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="hero-page-container">
      <div className="hero-page-details">
        <div className="hero-page-text">
          <h3 data-aos="fade-up" data-aos-duration="2000">
            {t("Download")} <span className="sportrex-text">Sportrex</span>
          </h3>
          <h3 className="second-h3" data-aos="fade-up" data-aos-duration="3000">
            <span className="gamers-text">Gamers</span> Wallet.
          </h3>
          <p data-aos="fade-up" data-aos-duration="3000">
            {t("The")} {t("gateway")} {t("for")} {t("the")} {t("next")}{" "}
            {t("generation")} {t("of")} {t("Gamers")}. {t("Your")} {t("games")},{" "}
            {t("Your")} {t("coins")}, {t("All")} {t("in")} {t("one")}{" "}
            {t("place")}. {t("Simple")}, {t("fun")}, {t("and")} {t("super")}{" "}
            {t("smart")}. 
          </p>
          <div className="heropage-buttons">
            <DownloadOnAppStoreMobile />
            <DownloadOnGooglePlayMobile />
          </div>
          <div className="qr-code-section">
            <div className="qr-code-container">
              <QRCode
                value="https://gamerswallet-landingpage.netlify.app/download"
                size={100}
                style={{ margin: "auto", display: "block" }}
              />
            </div>
            <div className="scan-section">
              <p>
                {t("Scan")} {t("to")} {t("download")} {t("app")}.{" "}
                {t("Available")} {t("on")} <br /> App Store {t("and")}{" "}
                Playstore.
              </p>
              <div className="store-icons">
                <a href="##">
                  <img
                    src={appleStoreIcon}
                    alt="Gamers Wallet Apple Store Icon"
                  />
                </a>
                <a href="##">
                  <img
                    src={playStoreIcon}
                    alt="Gamers Wallet Play Store Icon"
                  />
                </a>
              </div>
            </div>
          </div>
          <p className="hero-page-spt-text">
            {t("Download")} Sportrex Gamers Wallet {t("and")} {t("earn")}{" "}
            {t("free")} SPT Token.
          </p>
          <PoweredBy />
        </div>
        <div className="hero-page-image">
          <img
            data-aos="fade-left"
            data-aos-duration="2000"
            src={heropageImage}
            alt="Gamers Heropage"
            className="heropage-desktop"
          />
        </div>
      </div>
      <div className="fixed-gif">
        <img src={heroPageGif} alt="" ref={fixedGifRef} />
      </div>
      <div className="download-btn-qr-code">
        <div
          onMouseEnter={handleToggle}
          onMouseLeave={disableToggle}
          className="fixed-download"
        >
          <Lottie
            options={defaultOptions}
            height={45}
            width={45}
            className="fixed-download-icon"
          />
        </div>
        <div className="play-scan-apple-scan" ref={fixedDownloadRef}>
          <div className="scan-play-store">
            <p>Scan to download on App Store</p>
            <QRCode
              value="https://sportrex.io"
              size={90}
              style={{ margin: "auto", display: "block" }}
            />
          </div>
          <div className="scan-app-store">
            <p>Scan to download on Play Store</p>
            <QRCode
              value="https://sportrex.io"
              size={90}
              style={{ margin: "auto", display: "block" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroPage;
